<div class="card border-0">
    <div (click)="menuService.setMenuStatus(false)" class="clickable">
        <div (click)="menuService.setMenuStatus(false)" class="container mt-3 {{widthClasses[width]}} border border-dark p-0" >
            <div class="card-header">
                <strong class="text-center">{{title}}</strong>
            </div>

            <div class="card-body">
                <ng-content></ng-content>
            </div>
            <div class="card-footer text-end  d-lg-flex" [ngClass]="{'justify-content-lg-between': leftButtons.length > 0, 'justify-content-lg-end': leftButtons.length === 0}">
                <ng-content select="[footer]"></ng-content>

                <div *ngIf="leftButtons.length > 0" class="text-start col-4"  style="padding: 0">
                    <button *ngFor="let btn of leftButtons"
                            (click)="btn.action()"
                            [disabled]="isBtnDisabled(btn)"
                            class="btn {{buttonClasses[btn.type]}} mx-1"
                            type="button">
                        {{btn.label}}
                    </button>
                </div>

                <div *ngIf="buttons" class="col-8 text-right" style="padding: 0">
                    <button *ngFor="let btn of buttons"
                            (click)="btn.action()"
                            [disabled]="isBtnDisabled(btn)"
                            class="btn {{buttonClasses[btn.type]}} mx-1"
                            type="button">
                        {{btn.label}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
